import { ToastContainer } from 'react-toastify';

import classNames from 'classnames';

import { FontAwesomeIcon } from '@hsp/react-component-library';
import { SECOND } from '@hsp/utilities';

import { NotificationCenterPanel } from '@c/notifications/components/panel';

import { useNotificationCenterIconConfiguration } from './hooks';

import cssClasses from './notification-center-icon.module.scss';

const NotificationCenterIcon = () => {
  const { handleClick, iconRef, isOpen, notificationCenter, panelRef, unreadCount } =
    useNotificationCenterIconConfiguration();

  return (
    <>
      <ToastContainer
        autoClose={10 * SECOND}
        closeButton={false}
        pauseOnFocusLoss={false}
      />
      <div
        className={classNames(cssClasses.notificationCenterIcon, { [cssClasses.open]: isOpen })}
        onClick={handleClick}
        ref={iconRef}>
        <span className="fa-2x fa-fw fa-layers">
          <FontAwesomeIcon
            icon={['fas', 'bell']}
            shake={unreadCount > 0 && !isOpen}
          />
          <span className={classNames('fa-layers-counter', cssClasses.iconBadge)}>{unreadCount}</span>
        </span>
      </div>
      {isOpen ? (
        <div ref={panelRef}>
          <NotificationCenterPanel {...notificationCenter} />
        </div>
      ) : null}
    </>
  );
};

export default NotificationCenterIcon;
